import {
  ShopperAiWrappedImageKeySchema,
  ShopperAiWrappedPageTypeSchema,
} from "@redotech/redo-model/shopper-ai-wrapped";
import * as z from "zod";

const RecommendationSchema_ = z.object({
  title: z.string(),
  description: z.string(),
  actionUrl: z.string().optional(),
});

export const RecommendationSchema: z.ZodType<RecommendationSchema> =
  RecommendationSchema_;
export interface RecommendationSchema
  extends z.infer<typeof RecommendationSchema_> {}

const ShopperAiWrappedPageSchema_ = z.object({
  type: ShopperAiWrappedPageTypeSchema,
  title: z.string(),
  bodyText: z.string(),
  metricValue: z.string().optional(),
  metricLabel: z.string().optional(),
  imageKey: ShopperAiWrappedImageKeySchema,
  recommendation: RecommendationSchema.optional(),
});

export const ShopperAiWrappedPageSchema: z.ZodType<ShopperAiWrappedPageSchema> =
  ShopperAiWrappedPageSchema_;
export interface ShopperAiWrappedPageSchema
  extends z.infer<typeof ShopperAiWrappedPageSchema_> {}

const ShopperAiWrappedOutputSchema_ = z.object({
  merchantName: z.string(),
  pages: z.array(ShopperAiWrappedPageSchema),
});

export const ShopperAiWrappedOutputSchema: z.ZodType<ShopperAiWrappedOutputSchema> =
  ShopperAiWrappedOutputSchema_;
export interface ShopperAiWrappedOutputSchema
  extends z.infer<typeof ShopperAiWrappedOutputSchema_> {}

export const getShopperAiWrapped = {
  name: "getShopperAiWrapped" as const,
  input: z.void(),
  output: ShopperAiWrappedOutputSchema,
};
